import HTTP from "./HTTP.js";
import SymfonyErrorFormatter from "./SymfonyErrorFormatter";

class AgencyServices {

  static getAgencies(status, include, exclude, cursor, filters = {}, limit = 10) {
    return HTTP.get(`agencies`, {
      params: {
        status: status,
        include: include,
        exclude: exclude,
        filters,
        limit,
        cursor
      }
    })
      .then(response => {
        return {
          data: response.data.agencies,
          meta: response.data.meta
        };
      })
      .catch(() => {
        return Promise.reject("Could not get End Point");
      });
  }

  static getAgency(agencyId, include, exclude) {
    return HTTP.get(`agencies/${agencyId}`, {
      params: {
        include,
        exclude
      }
    })
      .then(response => {
        return response.data;
      })
      .catch(() => {
        return Promise.reject("Could not get End Point");
      });
  }

  static updateAgency(agency) {
    return HTTP.post(`agencies/${agency.id}`, agency)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return SymfonyErrorFormatter.clean(error.response);
      });
  }

  static updatePermission(agency, permission) {
    return HTTP.post(`agencies/${agency.id}/permissions/${permission.id}`, permission)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return SymfonyErrorFormatter.clean(error.response);
      });
  }

  static createAgency(agency) {
    agency.status = "published";
    return HTTP.post(`agencies`, agency)
      .then(response => {
        // Transformer needs to include address by default;
        return response.data;
      })
      .catch(error => {
        return SymfonyErrorFormatter.clean(error.response);
      });
  }

  static getCampaignCount(agency) {
    return HTTP.get(`agencies/${agency.id}/campaign/count`)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return SymfonyErrorFormatter.clean(error.response);
      });
  }

  static getSignifiProductData(agencyId, agentCampaign) {
    return HTTP.post(`agencies/signifi/product/${agencyId}`, agentCampaign)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return SymfonyErrorFormatter.clean(error.response);
      });
  }
}

export default AgencyServices;
